/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Hourglass(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    fill='none'
                    fillRule='evenodd'
                    id='svg_12'
                    transform='matrix(0.5610411442188236,0,0,0.4593360647124508,-57.276861015444474,-27.081958164097458) '
                >
                    <g
                        id='svg_15'
                        stroke={iconColor || '#FFF'}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2.5'
                    >
                        <g
                            id='svg_16'
                            stroke='null'
                        >
                            <path
                                d='m123.469311,85.151257c-7.66975,0 -13.88889,-6.31481 -13.88889,-14.10256l0,-9.40171l27.77778,0l0,9.40171c0,7.78775 -6.21913,14.10256 -13.88889,14.10256z'
                                id='svg_20'
                                stroke='null'
                            />
                            <path
                                d='m106.375301,62.181167l34.18803,0'
                                id='svg_19'
                                stroke='null'
                            />
                            <path
                                d='m123.469311,85.151257c-7.66975,0 -13.88889,6.31481 -13.88889,14.10256l0,9.40171l27.77778,0l0,-9.40171c0,-7.78775 -6.21913,-14.10256 -13.88889,-14.10256z'
                                id='svg_18'
                                stroke='null'
                            />
                            <path
                                d='m106.375301,108.121347l34.18803,0'
                                id='svg_17'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}